import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getRenewalReminderListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `renewal_reminder?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getRenewalListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `renewal?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getVehicleDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `get_vehicle_details/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitRenewalAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `renewal`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const saveAttachmentApi = async (id, body) => {
  try {
    const response = await axios.put(
      apiUrl + `renewal/add_attachment/` + id,
      body,
      {
        headers: header,
      }
    );
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateRenewalAPI = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `renewal/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getRenewalDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `renewal/view/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getRenewalEditApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `renewal/edit/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getRenewalReminderDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `renewal_reminder/view/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
